import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
const images = require.context("../assets/images", false);

function Team() {
    const sectionRef = useRef(null);
  const [startCount, setStartCount] = useState(false);

  const [years, setYears] = useState(0);
  const [families, setFamilies] = useState(0);
  const [reviews, setReviews] = useState(0);
  const [clients, setClients] = useState(0);

  // Detect section visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStartCount(true);
          observer.disconnect(); // run only once
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
  }, []);

  // Counter Animation
  useEffect(() => {
    if (!startCount) return;

    const animateCounter = (setter, target, duration = 2000) => {
      let start = 0;
      const increment = target / (duration / 20);

      const counter = setInterval(() => {
        start += increment;
        if (start >= target) {
          setter(target);
          clearInterval(counter);
        } else {
          setter(Math.ceil(start));
        }
      }, 20);
    };

    animateCounter(setYears, 12);
    animateCounter(setFamilies, 35);
    animateCounter(setReviews, 98);
    animateCounter(setClients, 700);

  }, [startCount]);

const teamMembers = [
  {
    img: images("./r1.webp"),
    name: "Rahul Walia",
    role: "Tour Operations",
  },
  {
    img: images("./ankit.jpg"),
    name: "Ankita",
    role: "Tour Sales",
  },
  {
    img: images("./Rajat-1.jpeg"),
    name: "Rajat",
    role: "Information Technology",
  },
  {
    img: images("./girsih.jpg"),
    name: "Girish Sati",
    role: "Transport",
  },
];

const NextArrow = ({ onClick }) => (
  <button className="custom-next" onClick={onClick}>
    <img src={images("./Forward.svg")} alt="next" />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button className="custom-prev" onClick={onClick}>
    <img src={images("./backward.svg")} alt="prev" />
  </button>
);


const sliderSettings = {
  dots: true,
  arrows: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 9999, // Above 768 disable slider
      settings: "unslick",
    },
  ],
};
 
	return (
		<div className="specialists backgrountem" ref={sectionRef}>
  <div className="inner-specialists">
    <div className="container">
      <div className="heading center">
        <h2>Our Team</h2>
      </div>
      <div className="row desktopview">
        <div className="col-md-6 col-lg-3">
          <div className="experts-card">
            <img src={images("./r1.webp")} alt="expert" />
            <div className="experts-card-details">
              <h5>Rahul Walia</h5>
              <p>Tour Operations</p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="experts-card">
            <img src={images("./ankit.jpg")} alt="expert" />
            <div className="experts-card-details">
              <h5>Ankita</h5>
              <p>Tour Sales</p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="experts-card">
            <img src={images("./Rajat-1.jpeg")} alt="expert" />
            <div className="experts-card-details">
              <h5>Rajat</h5>
              <p>Information Technology</p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="experts-card">
            <img src={images("./girsih.jpg")} alt="expert" />
            <div className="experts-card-details">
              <h5>Girish Sati</h5>
              <p>Transport</p>
            </div>
          </div>
        </div>
      </div>

      <Slider {...sliderSettings} className="team-slider">
  {teamMembers.map((member, index) => (
    <div key={index}>
      <div className="col-md-6 col-lg-3">
        <div className="experts-card">
          <img src={member.img} alt="expert" />
          <div className="experts-card-details">
            <h5>{member.name}</h5>
            <p>{member.role}</p>
          </div>
        </div>
      </div>
    </div>
  ))}
</Slider>
    </div>
    <div className="review-bar mt-5">
      <div className="container">
        <div className="inner-review-bar">
          <div className="row">
            <div className="col-6 col-md-3">
              <div className="review-bar-card color-white center">
                <h2>{years}+</h2>
                <p>Years Of Experience</p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="review-bar-card color-white center">
                <h2>{families}+</h2>
                <p>Local Families Supported</p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="review-bar-card color-white center">
                <h2>{reviews}%</h2>
                <p>Positive Reviews</p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="review-bar-card color-white center">
                <h2>{clients}+</h2>
                <p>Happy Clients</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
	);
}

export default Team;
